import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./PhoneInput.scss";

const PhoneFormInput = ({
  label,
  divClassName,
  name,
  value,
  handleBlur,
  error,
  touched,
  setFieldValue,
  placeholder,
  inputClass
}) => {
  const [dialCode, setDialCode] = React.useState("61");

  const handleInputChange = (phoneNumber, data) => {
    if (data && data.dialCode) {
      setDialCode(data.dialCode);
    }
    setFieldValue(name, phoneNumber);
  };

  return (
    <div className={divClassName}>
      {label && <p className="mb-2 text-sm font-medium text-gray-700">{label}</p>}
      <div className="relative">
        <div className="absolute top-1/2 -translate-y-1/2 left-[50px] z-10 pointer-events-none text-[#303030] font-poppins text-[16px]">
          +{dialCode}
        </div>
        <PhoneInput
          country={"au"}
          value={value}
          onChange={handleInputChange}
          onBlur={handleBlur}
          enableSearch={false}
          disableSearchIcon={true}
          disableCountryCode={true}
          inputProps={{
            name: name,
            placeholder: placeholder || "Contact Number",
          }}
          placeholder={placeholder || "Contact Number"}
          containerClass="react-tel-input"
          inputClass={inputClass || "form-control"}
          buttonClass="flag-dropdown"
          dropdownClass="country-list"
          inputStyle={{
            paddingLeft: `calc(50px + ${dialCode.length * 10}px + 10px)`
          }}
        />
      </div>
      {error && touched ? (
        <span className="text-red-600 sm:text-[10px] md:text-[12px] font-[600] ms-1">
          {error}
        </span>
      ) : null}
    </div>
  );
};

export default PhoneFormInput;
